// extracted by mini-css-extract-plugin
export default {"label":"CustomInputText_label__g430z","labelText":"CustomInputText_labelText__4phvs","required":"CustomInputText_required__Ks6+7"};